<template>
  <div class="flow-common-form-approval-default">
    <template v-if="hasData">
      <pre class="view-data-content">{{ formattedData }}</pre>
    </template>
    <template v-else>
      <div class="view-data-empty">
        <Hint type="empty">
          <div>暂无审批数据</div>
        </Hint>
      </div>
    </template>
  </div>
</template>

<script>
import Hint from '../../../../../elements/Hint'
export default {
  name: 'FlowCommonFormApprovalDefault',
  components: {
    Hint
  },
  props: {
    viewData: Object
  },
  computed: {
    hasData () {
      return this.viewData && Object.keys(this.viewData).length > 0
    },
    formattedData () {
      return JSON.stringify(this.viewData, null, 2)
    }
  }
}
</script>

<style lang="scss">
.flow-common-form-approval-default {
  padding: 16px;
  font-size: 13px;

  .view-data-content {
    margin: 0;
    padding: 12px;
    background: #f5f7fa;
    border-radius: 4px;
    font-size: 13px;
    line-height: 1.5;
    overflow: auto;
    max-height: 400px;
  }

  .view-data-empty {
    color: #909399;
    text-align: center;
    padding: 40px 0;
  }
}
</style>
